import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const NoticeIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M16.1782 17.6566L15.6958 17.0823H15.6958L16.1782 17.6566ZM3.82116 17.6566L4.30356 17.0823L4.30356 17.0823L3.82116 17.6566ZM3.82116 4.4767L3.33877 3.90242L3.33877 3.90242L3.82116 4.4767ZM11.6663 3.31665H4.99967V4.81665H11.6663V3.31665ZM14.6663 3.31665H11.6663V4.81665H14.6663V3.31665ZM17.4163 6.06665C17.4163 4.54787 16.1851 3.31665 14.6663 3.31665V4.81665C15.3567 4.81665 15.9163 5.3763 15.9163 6.06665H17.4163ZM17.4163 8.26665V6.06665H15.9163V8.26665H17.4163ZM17.4163 16.6666V8.26665H15.9163V16.6666H17.4163ZM16.6606 18.2309C17.1237 17.8418 17.4163 17.2833 17.4163 16.6666H15.9163C15.9163 16.7926 15.8578 16.9463 15.6958 17.0823L16.6606 18.2309ZM14.9997 18.8166C15.6024 18.8166 16.2013 18.6167 16.6606 18.2309L15.6958 17.0823C15.5299 17.2216 15.281 17.3166 14.9997 17.3166V18.8166ZM4.99967 18.8166H14.9997V17.3166H4.99967V18.8166ZM3.33877 18.2309C3.79802 18.6167 4.39691 18.8166 4.99967 18.8166V17.3166C4.71838 17.3166 4.46942 17.2216 4.30356 17.0823L3.33877 18.2309ZM2.58301 16.6666C2.58301 17.2833 2.87563 17.8418 3.33877 18.2309L4.30356 17.0823C4.14157 16.9463 4.08301 16.7926 4.08301 16.6666H2.58301ZM2.58301 5.46665V16.6666H4.08301V5.46665H2.58301ZM3.33877 3.90242C2.87563 4.29146 2.58301 4.85004 2.58301 5.46665H4.08301C4.08301 5.34066 4.14157 5.18705 4.30356 5.05098L3.33877 3.90242ZM4.99967 3.31665C4.39691 3.31665 3.79802 3.51665 3.33877 3.90242L4.30356 5.05098C4.46942 4.91165 4.71838 4.81665 4.99967 4.81665V3.31665Z"
                stroke="none"
                fill="currentColor"
            />
            <path
                d="M13.3327 11.3H6.66602"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3366 7.69995H6.66992"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3327 14.7H6.66602"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 4.69995H8.67709H9H11H11.3229H12V4.31799V3.69995V3.19995C12 2.09538 11.1046 1.19995 10 1.19995C8.89543 1.19995 8 2.09538 8 3.19995V3.69995V4.31799V4.69995ZM10 3.86662C10.3682 3.86662 10.6667 3.56814 10.6667 3.19995C10.6667 2.83176 10.3682 2.53328 10 2.53328C9.63181 2.53328 9.33333 2.83176 9.33333 3.19995C9.33333 3.56814 9.63181 3.86662 10 3.86662Z"
                stroke="none"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </SvgIcon>
    );
};
